export default __webpack_public_path__ + "static/media/lock-check-circle-tc.817373bb.svg";